import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/global.css'; // Seu CSS global
import Calendar from './Calendar/Calendar';
import { CalendarMonth, TwoWheeler, Celebration, Place } from '@mui/icons-material';

function Eventos() {
  
  // salvar log de navegação
  useEffect(() => {
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    //console.log("Salvando log de navegação para a página de calendário...");
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Navegação",
      logModulo: "Página de Calendário",
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });
  }, []);

  return (
    <div style={{ paddingBottom: '80px' }}>
      <main>
        <div className='headerMain'>
          <label className='labelTitulo' ><h2>Eventos Brasil Extremos</h2></label>
        </div>

        <div className='d-flex w100 flex-column flex-md-row justify-content-center align-items-start gap-4'>
          <div className='boxCenter'>
            <TwoWheeler style={{ width: 50, height: 50 }} />
              <h2>III Moto Fest de Cabedelo - PB (2026)</h2>
              <p className='pt1'><h3>O Moto Grupo Brasil Extremos esteve presente no III Moto Fest de Cabedelo - PB, em abril de 2026, um evento que reuniu motociclistas de todo o país para celebrar a paixão por motos e a amizade entre a irmandade motociclista.</h3></p>
          </div>
          <div className='boxCenter'>
            <Celebration style={{ width: 50, height: 50 }} />
              <h2>Confraternização Anual</h2>
              <p className='pt1'><h3>Participe da nossa confraternização anual, onde membros de todas as regionais se reúnem para celebrar a amizade e a paixão por motocicletas. Um evento cheio de diversão, música e, claro, muitas motos!</h3></p>
          </div>
          <div className='boxCenter'>
            <Place style={{ width: 50, height: 50 }} />
              <h2>Encontros Regionais</h2>
              <p className='pt1'><h3>Nossos encontros regionais são uma ótima oportunidade para conhecer outros membros do Moto Grupo Brasil Extremos em sua região. Junte-se a nós para um dia de passeio, boa comida e ótimas companhias.</h3></p>
          </div>
          <div className='boxCenter'>
            <CalendarMonth style={{ width: 50, height: 50 }} />
            <h2>Calendário de Eventos</h2>
            <p className='pt1'><h3>Fique por dentro dos próximos eventos do Moto Grupo Brasil Extremos. Participe de nossos encontros, passeios e confraternizações. Acompanhe nosso calendário para não perder nenhuma aventura sobre duas rodas!</h3></p>
          </div>
        </div>
        <div>
          <Calendar />
        </div>
      </main>
    </div>
  );
}

export default Eventos;